import React from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../../components/grid-container/GridContainer"
import UiImageCard from "../../../components/cards/UiImageCard"
import Gym from "../../../../../styles/img/memberships/gym.jpg"
import Odeon from "../../../../../styles/img/memberships/odeon.jpg"
import Pelaton from "../../../../../styles/img/memberships/pelatonimg.png"
import { UiButtonOutline } from "../../../components/form/UiButton"

export default function MembershipsList(props) {
    

    return (
        <>
        <div className='sb-membership-list'>
            <UiSingleRow>
                <UiCol lg="11">
                    <UiSingleRow>
                        <UiCol lg="4">
                            <UiImageCard image={Gym} heading="Gym" ratings="4.8" reviews="122" footer={true }/>
                        </UiCol>
                        <UiCol lg="4">
                            <UiImageCard image={Gym} heading="Gym" ratings="4.8" reviews="122" footer={true }/>
                        </UiCol>
                        <UiCol lg="4">
                            <UiImageCard image={Gym} heading="Gym" ratings="4.8" reviews="122" footer={true }/>
                        </UiCol>
                        <UiCol lg="4">
                            <UiImageCard image={Gym} heading="Gym" ratings="4.8" reviews="122" footer={true }/>
                        </UiCol>
                        <UiCol lg="4">
                            <UiImageCard image={Gym} heading="Gym" ratings="4.8" reviews="122" footer={true }/>
                        </UiCol>
                        <UiCol lg="4">
                            <UiImageCard image={Gym} heading="Gym" ratings="4.8" reviews="122" footer={true }/>
                        </UiCol>
                    </UiSingleRow>
                    <UiButtonOutline isLoading={true} btnName="View All" />
                </UiCol>
            </UiSingleRow>
        </div>
        </>
    )
}
